import React, { useContext, useMemo } from 'react';

// GLOBAL VARIABLES
import { ACTIONS } from 'columns.js';
import { INTERFACE } from 'pathnames.js';
import { COLUMNS } from './columns.js';

// HELPERS
import { ListContext } from 'helpers/getListData';

// GLOBAL PARTS
import Table from 'parts/table/Table.js';

// STYLES
import styles from './detailsTable.module.scss';

// MAIN COMPONENT
const DetailsTable = () => {
  // CONTEXT
  const {
    data: { header = {} },
    result
  } = useContext(ListContext) || {};

  // MEMOS
  const columns = useMemo(
    () =>
      Object.keys(header).map(key =>
        Object.assign(
          {},
          COLUMNS.find(column => column.key === key),
          {
            key,
            label: header[key],
            size: 'md'
          }
        )
      ),
    [header]
  );
  const actions = useMemo(
    () => (result[0]?.sales_id ? [ACTIONS.open(INTERFACE.sales, 'sales_id')] : undefined),
    [result]
  );

  // RENDER
  return <Table className={styles.table} columns={columns} actions={actions} sortable={false} showNumber />;
};

// EXPORT
export default DetailsTable;
